import { SVGProps } from "react";

const ProSearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.5 7.5a.5.5 0 0 1 .5.5v5.417a2.584 2.584 0 0 1-5.167 0V13a.5.5 0 0 1 1 0v.417a1.583 1.583 0 0 0 3.167 0V8a.5.5 0 0 1 .5-.5Z"
    />
    <path
      fill="currentColor"
      d="M3.1 5.843a.5.5 0 0 1 0 .98l-.1.01h-.417a1.584 1.584 0 0 0 0 3.167H8l.1.01a.5.5 0 0 1 0 .98L8 11H2.583a2.584 2.584 0 0 1 0-5.167H3l.1.01ZM13.672 5.013a2.583 2.583 0 0 1-.255 5.154H13a.5.5 0 0 1 0-1h.417a1.584 1.584 0 0 0 .156-3.16L13.417 6H8a.5.5 0 0 1 0-1h5.417l.255.013Z"
    />
    <path
      fill="currentColor"
      d="M7.839.013a2.584 2.584 0 0 1 2.328 2.57V3a.5.5 0 0 1-1 0v-.417A1.584 1.584 0 0 0 7.74 1.008L7.583 1A1.583 1.583 0 0 0 6 2.583V8a.5.5 0 0 1-1 0V2.583A2.583 2.583 0 0 1 7.583 0l.256.013Z"
    />
  </svg>
);

export default ProSearchIcon;
